import React, { useContext, useEffect, useState } from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'




const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
  
        title, 
        html, 
        icon, 
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',  
        showCancelButton: true, 
        cancelButtonColor: '#d33',  
        cancelButtonText: 'Cancelar' 
    }) 
}


const questions = [
    { id: 1, text: "¿Qué tan satisfecho estás con nuestro servicio?" },
    { id: 2, text: "¿Recomendarías nuestro producto?" },
    { id: 3, text: "¿Qué tan fácil fue usar nuestra aplicación?" },
  ];


export const Encuestas =  () => {

    const [ isLoading, setIsLoading ] = useState(false);
    const [ isEnded, setIsEnded ] = useState(false);
    useHideMenu(true);

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();
    
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [responses, setResponses] = useState(
        new Array(questions.length).fill(5) // Valores iniciales en el medio (1-10)
    );

    const handleSliderChange = (value) => {
        const newResponses = [...responses];
        newResponses[currentQuestionIndex] = value;
        setResponses(newResponses);
    };

    const handleReset = () => {
        setCurrentQuestionIndex(0);
        setIsEnded(false);
        
    };


    const handleNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };



    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
        setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const handleSubmit = () => {
        console.log("Respuestas:", responses);
        setIsEnded(true);
        // alert("Respuestas:", responses);
        // alert("Encuesta completada. ¡Gracias!");

    };

    
   

    // if( usuario.uidUsuario === null ) {
    //     return(
    //         <>
    //         </>
    //     )
    // }
    // else if( !pantallas.includes("videoslistas") ) {
    //     return( <NoAcceso /> )
    // } 
    // else 
    if( isEnded ) {
        return (

            <div className=' container' style={{ position: "relative", height: "100vh", display: "flex",
                justifyContent: "center",
                alignItems: "center",  }}>
                <AnimatePresence mode="wait">
                <motion.div
                    key={currentQuestionIndex}
                    initial={{ opacity: 0, x: 100 }} // Aparece desde la derecha
                    animate={{ opacity: 1, x: 0 }} // Se centra en pantalla
                    exit={{ opacity: 0, x: -100 }} // Sale hacia la izquierda
                    transition={{ duration: 0.7 }}
                    style={{ position: "absolute", width: "100%" }}
                >
                    
                    <div className=' card-body ' >

                        <h1>Respuestas</h1>
                        <button className="btn btn-danger mx-1" onClick={handleReset}>Nueva</button>
                                               
                        <Table responsive striped hover>

                            <thead width= "100%">
                                <tr>
                                    <th width={"90%"}>Pregunta</th>
                                    <th width={"10%"}>Respuesta</th>
                                    
                                </tr>
                            </thead>

                            <tbody width= "100%">
                                {questions
                                .map((item, i) => (
                                    <tr key={ i }>
                                        <td width={"90%"}>{ item.text.trim() }</td>
                                        <td width={"10%"}>{ responses[i] }</td>
                                        
                                        
                                    </tr>

                                ))}
                            </tbody>
                            
                            <tfoot width= "100%">
                                
                            </tfoot>

                        </Table>
                    </div>
                </motion.div>
                </AnimatePresence>
            </div>
        )
    } 
    else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{height:'90vh', display: "flex",
        justifyContent: "center",
        alignItems: "center", }}>

                    <div style={{ textAlign: "center", marginTop: "50px", width: "100%" }}>
                        <h1>Encuesta</h1>
                        <div style={{ position: "relative", height: "150px", overflow: "hidden" }}>
                            <AnimatePresence mode="wait">
                            <motion.div
                                key={currentQuestionIndex}
                                initial={{ opacity: 0, x: 100 }} // Aparece desde la derecha
                                animate={{ opacity: 1, x: 0 }} // Se centra en pantalla
                                exit={{ opacity: 0, x: -100 }} // Sale hacia la izquierda
                                transition={{ duration: 0.7 }}
                                style={{ position: "absolute", width: "100%" }}
                            >
                                <h2>{questions[currentQuestionIndex].text}</h2>
                            </motion.div>
                            </AnimatePresence>
                        </div>
                        <input
                            type="range"
                            min="1"
                            max="10"
                            value={responses[currentQuestionIndex]}
                            onChange={(e) => handleSliderChange(Number(e.target.value))}
                        />
                        <p>Valor seleccionado: {responses[currentQuestionIndex]}</p>
                        <div style={{ marginTop: "20px" }}>
                            <button className="btn btn-primary mx-1" onClick={handlePrevious} disabled={currentQuestionIndex === 0}>
                            Anterior
                            </button>
                            {currentQuestionIndex === questions.length - 1 ? (
                            <button className="btn btn-success mx-1" onClick={handleSubmit}>Enviar</button>
                            ) : (
                            <button className="btn btn-primary mx-1" onClick={handleNext}>Siguiente</button>
                            )}
                        </div>
                     </div>
                   
                </div>

            </>
        );
    }

}